export const statuses = {
    draft: 'text-gray-500 bg-gray-200 ring-gray-400/20',       // Soft gray
    ready: 'text-green-700 bg-green-100 ring-green-600/20',    // Green
    live: 'text-yellow-800 bg-yellow-100 ring-yellow-600/20',  // Yellow
    complete: 'text-blue-700 bg-blue-100 ring-blue-500/20',    // Blue
  };